export const joinPlaceNames = (places?: { placeName: string | null }[] | null) =>
  places
    ?.map(({ placeName }) => placeName)
    .filter(Boolean)
    .join(', ') ?? '';
